<script>
	import Bubble from '$lib/Components/Layout/Bubble/Bubble.svelte';
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import GetAFreeEstimate from '$lib/PageSections/GetAFreeEstimate/GetAFreeEstimate.svelte';

	import img1 from './images/IW-Resources-Mullions-011.jpg';
	import img2 from './images/IW-Resources-Mullions-02.jpg';
	import img3 from './images/IW-Resources-Mullions-03.jpg';
	import img4 from './images/IW-Resources-Mullions-04.jpg';
	import img5 from './images/IW-Resources-Mullions-05.jpg';
	import img6 from './images/IW-Resources-Mullions-06.jpg';
</script>

<Section backgroundColor="white">
	<h2>Mullion Definition</h2>
	<p>
		A mullion divides a window into smaller, more manageable units. This was
		true back when large sheets of glass were impossible to manufacture, and
		it’s true now of large storm windows or inserts. Mullions help separate and
		support the glass either vertically or horizontally. For inserts, mullions
		can help make daily removal and cleaning easier.
	</p>
	<Image src={img1} alt="Indow window insert storm window mullion." />
</Section>

<Section backgroundColor="white">
	<h2>How Mullions Work with Storm Windows</h2>
	<p>
		For those looking to get a storm windows for a larger window, glass wall, or
		floor to ceiling window, using mullions to divide and conquer might be the
		way to go. Two smaller interior storm windows are easier to handle than
		large storm windows.
	</p>
	<Image
		src="/static/routes/about-indow/how-to-order/mullions/IW-1-2-3-4-5-mullion-diagram.gif"
		alt="indow window insert storm window mullion"
	/>
	<p>
		Indow window inserts are an acrylic insert surrounded by compression tubing
		that press into place on the inside frame of your glass window or wall. They
		increase energy efficiency just like traditional storm windows, but have
		added benefits such as being easy to remove and blocking up to 70% of
		outside noise.
	</p>
	<Image src={img2} alt="Indow window insert storm window mullion." />
	<p>
		For Indow inserts to work with extremely large windows, we add a mullion.
		It’s basically an H frame that divides the window frame into two even areas
		that two smaller inserts can be inserted into. The H frame will match the
		color of the insert (which matches your window frame) and can be adjusted to
		divide along a natural split.
	</p>
	<Image
		src="/static/routes/about-indow/how-to-order/mullions/vertical-mullion.gif"
		alt="indow window insert storm window mullion"
	/>
</Section>

<Section backgroundColor="grey-light">
	<h2>Testimonial</h2>
	<Image src={img3} alt="Indow window insert storm window mullion." />
	<p class="text-xl text-indow-blue! italic">
		Joseph Casillo was updating his apartment building that included landmark
		windows. They were over 100 years old and beautiful, but let in drafts and
		grime. Casillo talked with 3 or 4 different vendors who provide large storm
		windows, but couldn’t find what he needed. When he spoke with Alma’s
		Interior Solutions (an Indow insert vendor), he finally found what he was
		looking for. Working with Indow inserts, Casillo was able to introduce a
		mullion exactly along the window sash line so that none of the landmark
		window was obscured.
	</p>
	<p>
		– Joseph Casillo, Senior Project Manager, 25 Broad St. New York, New York
	</p>
</Section>

<Section backgroundColor="white">
	<h2>How are Mullions Installed?</h2>
	<p>
		A window insert, just like a window, can be divided in two (though sometimes
		more) sections with a mullion either horizontally or vertically. This means
		you’ll have two window inserts side by side, or one on top and one on
		bottom. What determines this is the size and shape of your original window.
		It happens most often with large window and large storm windows.
	</p>
	<Image src={img4} alt="Indow window insert storm window mullion." />
	<p>
		All Indow mullion kits include an H Bar to divide you window frame. Imagine
		sliding the inserts into the H for the top and bottom divide, then flip the
		H on its side for the side by side version. Standard lengths are in one foot
		increments up 8’ and can be shipped UPS Ground.
	</p>
	<p>
		Custom cuts are exact lengths and available with custom fee. Specialty F bar
		profile is available for inside corners. <a href="/about-indow/contact"
			>Contact us</a
		> for more details.
	</p>
</Section>

<Section backgroundColor="blue">
	<h2>Benefits of Using Mullions</h2>
	<Bubble backgroundColor="transparent">
		<ul class="marker:text-indow-white">
			<li>
				Some extremely large windows are too large for one insert (imagine
				trying to install those large storm windows) – mullions divide it into
				sections making it possible to place inserts.
			</li>
			<li>Be able to open your window by removing one of two inserts.</li>
			<li>
				Mullions can be used with any type of insert grade and will not alter
				performance of the insert if installed correctly.
			</li>
		</ul>
	</Bubble>
</Section>

<Section backgroundColor="white">
	<Image src={img5} alt="Indow window insert storm window mullion." />
</Section>

<Section backgroundColor="white">
	<h2>Mullion Samples &amp; Instructions</h2>
	<p>
		Fill out a <a href="/how-to/get-indow-inserts">free estimate form</a> to get
		connected with your Fit Specialist who can provide you with samples of our
		mullions. Looking
		<a href="/guides/how-to-measure-for-mullions"
			>for mullion installation instructions</a
		>? We’re also <a href="/about-indow/contact">available to help</a> with any questions.
	</p>
	<Image src={img6} alt="Indow window insert storm window mullion." />
</Section>

<GetAFreeEstimate />
